/**
 * Tax rate constant
 * Adjust this value as needed for different tax rates
 */
export const TAX_RATE = 0.0825; // 8.25% tax rate

/**
 * Valid reasons for complimentary orders
 * @constant {string[]}
 */
export const COMPLIMENTARY_ORDER_REASONS = [
  'customer_service',
  'warranty_replacement',
  'promotional',
  'employee_benefit',
  'partnership',
  'quality_issue',
  'goodwill',
  'other',
];

/**
 * Server URL for API requests
 * @type {string}
 */
export const SERVER_URL = `${
  import.meta.env.VITE_API_URL || 'http://localhost:8080'
}${import.meta.env.VITE_API_VERSION || '/api/v1'}`;
